var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseGray71(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E30613",
    d: "M866.4 156.1c-.9-1.1-2-2.1-3-3l3 3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ADBABD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M764.5 259.5l-505 505M764.5 764.5l-505-505"
  }))));
}

export default SvgCloseGray71;